// extracted by mini-css-extract-plugin
export default {"modalPaper":"NcSP_S3OuHLOcbuBSR8i","modalInfo":"Rx6wBj6p11ISpVXE5iB8"};